<p class="notion-paragraph__text px-[16px] py-[8px]">
  @for(r of data.paragraph.rich_text; track $index) {
  <app-notion-text-component [data]="r"></app-notion-text-component>
  }
</p>
